/* eslint-disable @typescript-eslint/consistent-type-imports */
import { useCallback } from 'react';
import { useLazyQueryInterop } from '@confluence/apollo-relay-interop';
import { expVal } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { LazyConfluenceSmartCreationModal } from './LazyConfluenceSmartCreationModal.ts';
import ConfluenceSmartCreationModalQuery, {
	ConfluenceSmartCreationModalQuery$data,
	ConfluenceSmartCreationModalQuery$variables,
} from './__generated__/ConfluenceSmartCreationModalQuery.graphql.ts';

export const usePreloadSmartCreationModal = (): (() => boolean) => {
	const { isRovoLLMEnabled } = useSessionData();
	const [preloadSmartCreationModalQuery] = useLazyQueryInterop<
		ConfluenceSmartCreationModalQuery$data,
		ConfluenceSmartCreationModalQuery$variables
	>(ConfluenceSmartCreationModalQuery);

	return useCallback(() => {
		if (
			!isRovoLLMEnabled &&
			expVal('remove_aifc_modal_preloading_non_rovo_tenants_exp', 'isEnabled', false)
		) {
			return false;
		}

		preloadSmartCreationModalQuery();
		void LazyConfluenceSmartCreationModal.preload();
		return true;
	}, [isRovoLLMEnabled, preloadSmartCreationModalQuery]);
};
